import {
	Component,
	inject,
	Injector,
	ChangeDetectionStrategy,
} from '@angular/core'
import { StudioTrpcService } from '@lg/ng-shared'
import * as Sys from '@lg/ng-shared'
import { AuthService } from '@lg/ng-shared'
import { ErrorService } from '@lg/ng-shared'
import { AppContext } from '@lg/ng-shared'
import { DevService } from './services/dev-service.js'

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class AppComponent {
	private readonly trpcService = inject(StudioTrpcService)
	private readonly authService = inject(AuthService)
	private readonly errorService = inject(ErrorService)
	private readonly injector = inject(Injector)
	private readonly devService = inject(DevService)

	constructor() {
		globalThis.Sys = Sys
		this.authService.errorLogger = (message) => this.errorService.error(message)
		AppContext.setForStudio({
			injector: this.injector,
		})
		globalThis.$api = this.trpcService
		globalThis.$dev = this.devService
	}
}
